import config from 'config';
import createClient, { Client, HeadersOptions } from 'openapi-fetch';
import { createContext } from 'react';

import { paths } from '../schema';

const defaultHeaders = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
} as const satisfies HeadersOptions;
export function createApiClient(accessToken: string | null | undefined) {
  return createClient<paths>({
    baseUrl: config.apiBaseUrl,
    headers: {
      ...defaultHeaders,
      ...(accessToken != null ? { Authorization: `Bearer ${accessToken}` } : {}),
    },
  });
}
export const ApiClientContext = createContext<Client<paths>>(createApiClient(null));
